/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AIVerificationResult
 */
export interface AIVerificationResult {
    /**
     * 
     * @type {string}
     * @memberof AIVerificationResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AIVerificationResult
     */
    'severity': string;
    /**
     * 
     * @type {boolean}
     * @memberof AIVerificationResult
     */
    'is_regulatory': boolean;
    /**
     * 
     * @type {string}
     * @memberof AIVerificationResult
     */
    'regulation': string;
    /**
     * 
     * @type {string}
     * @memberof AIVerificationResult
     */
    'document_analysis_id': string;
    /**
     * 
     * @type {ApplianceIndex}
     * @memberof AIVerificationResult
     */
    'appliance_index'?: ApplianceIndex;
    /**
     * 
     * @type {DefectIndex}
     * @memberof AIVerificationResult
     */
    'defect_index'?: DefectIndex;
    /**
     * 
     * @type {boolean}
     * @memberof AIVerificationResult
     */
    'original_outcome': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AIVerificationResult
     */
    'outcome': boolean;
    /**
     * 
     * @type {string}
     * @memberof AIVerificationResult
     */
    'variable_value': string;
    /**
     * 
     * @type {string}
     * @memberof AIVerificationResult
     */
    'validation_name': string;
    /**
     * 
     * @type {string}
     * @memberof AIVerificationResult
     */
    'validation_desc': string;
    /**
     * 
     * @type {OverriddenBy}
     * @memberof AIVerificationResult
     */
    'overridden_by'?: OverriddenBy;
    /**
     * 
     * @type {OverriddenAt}
     * @memberof AIVerificationResult
     */
    'overridden_at'?: OverriddenAt;
    /**
     * 
     * @type {OverriddenReason}
     * @memberof AIVerificationResult
     */
    'overridden_reason'?: OverriddenReason;
    /**
     * 
     * @type {Array<DocumentLocation>}
     * @memberof AIVerificationResult
     */
    'location'?: Array<DocumentLocation>;
    /**
     * 
     * @type {OriginalReason}
     * @memberof AIVerificationResult
     */
    'original_reason'?: OriginalReason;
}
/**
 * 
 * @export
 * @interface Address2
 */
export interface Address2 {
}
/**
 * 
 * @export
 * @interface AnalysisResponse
 */
export interface AnalysisResponse {
    /**
     * 
     * @type {DocumentAIAnalysis}
     * @memberof AnalysisResponse
     */
    'analysis': DocumentAIAnalysis;
    /**
     * 
     * @type {AssetId}
     * @memberof AnalysisResponse
     */
    'asset_id': AssetId;
    /**
     * 
     * @type {AssetAdd1}
     * @memberof AnalysisResponse
     */
    'asset_add_1': AssetAdd1;
    /**
     * 
     * @type {ContractorName}
     * @memberof AnalysisResponse
     */
    'contractor_name': ContractorName;
}
/**
 * 
 * @export
 * @interface ApplianceIndex
 */
export interface ApplianceIndex {
}
/**
 * 
 * @export
 * @interface Asset
 */
export interface Asset {
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'last_modified': string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'tenant_id': string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'address_1': string;
    /**
     * 
     * @type {Address2}
     * @memberof Asset
     */
    'address_2': Address2;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'county': string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'postcode': string;
    /**
     * 
     * @type {string}
     * @memberof Asset
     */
    'uprn': string;
}
/**
 * 
 * @export
 * @interface AssetAdd1
 */
export interface AssetAdd1 {
}
/**
 * 
 * @export
 * @interface AssetAuditEvent
 */
export interface AssetAuditEvent {
    /**
     * 
     * @type {string}
     * @memberof AssetAuditEvent
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAuditEvent
     */
    'asset_id': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAuditEvent
     */
    'audit_description': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAuditEvent
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAuditEvent
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface AssetByAddressResponse
 */
export interface AssetByAddressResponse {
    /**
     * 
     * @type {AssetByAddressResponseAsset}
     * @memberof AssetByAddressResponse
     */
    'asset': AssetByAddressResponseAsset;
    /**
     * 
     * @type {AssetByAddressResponseAddressResult}
     * @memberof AssetByAddressResponse
     */
    'address_result': AssetByAddressResponseAddressResult;
}
/**
 * 
 * @export
 * @interface AssetByAddressResponseAddressResult
 */
export interface AssetByAddressResponseAddressResult {
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAddressResult
     */
    'address_1': any;
    /**
     * 
     * @type {Address2}
     * @memberof AssetByAddressResponseAddressResult
     */
    'address_2': Address2;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAddressResult
     */
    'city': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAddressResult
     */
    'county': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAddressResult
     */
    'postcode': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAddressResult
     */
    'UPRN': any;
}
/**
 * 
 * @export
 * @interface AssetByAddressResponseAsset
 */
export interface AssetByAddressResponseAsset {
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'created': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'last_modified': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'tenant_id': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'address_1': any;
    /**
     * 
     * @type {Address2}
     * @memberof AssetByAddressResponseAsset
     */
    'address_2': Address2;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'city': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'county': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'postcode': any;
    /**
     * 
     * @type {any}
     * @memberof AssetByAddressResponseAsset
     */
    'uprn': any;
}
/**
 * 
 * @export
 * @interface AssetComplianceSnapshot
 */
export interface AssetComplianceSnapshot {
    /**
     * 
     * @type {string}
     * @memberof AssetComplianceSnapshot
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssetComplianceSnapshot
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof AssetComplianceSnapshot
     */
    'tenant_id': string;
    /**
     * 
     * @type {number}
     * @memberof AssetComplianceSnapshot
     */
    'compliant_assets': number;
    /**
     * 
     * @type {number}
     * @memberof AssetComplianceSnapshot
     */
    'assets_with_warning': number;
    /**
     * 
     * @type {number}
     * @memberof AssetComplianceSnapshot
     */
    'assets_requiring_attention': number;
}
/**
 * 
 * @export
 * @interface AssetDocumentReturnType
 */
export interface AssetDocumentReturnType {
    /**
     * 
     * @type {string}
     * @memberof AssetDocumentReturnType
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssetDocumentReturnType
     */
    'document_name': string;
    /**
     * 
     * @type {string}
     * @memberof AssetDocumentReturnType
     */
    'document_type': string;
    /**
     * 
     * @type {string}
     * @memberof AssetDocumentReturnType
     */
    'upload_date': string;
    /**
     * 
     * @type {string}
     * @memberof AssetDocumentReturnType
     */
    'uploaded_by_username': string;
    /**
     * 
     * @type {string}
     * @memberof AssetDocumentReturnType
     */
    'filename': string;
    /**
     * 
     * @type {Expiry}
     * @memberof AssetDocumentReturnType
     */
    'expiry'?: Expiry;
}
/**
 * 
 * @export
 * @interface AssetId
 */
export interface AssetId {
}
/**
 * 
 * @export
 * @interface AssetReminderReturnType
 */
export interface AssetReminderReturnType {
    /**
     * 
     * @type {string}
     * @memberof AssetReminderReturnType
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssetReminderReturnType
     */
    'asset_id': string;
    /**
     * 
     * @type {string}
     * @memberof AssetReminderReturnType
     */
    'reminder_type': string;
    /**
     * 
     * @type {string}
     * @memberof AssetReminderReturnType
     */
    'reminder_date': string;
    /**
     * 
     * @type {string}
     * @memberof AssetReminderReturnType
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AssetReminderReturnType
     */
    'created_by_username': string;
    /**
     * 
     * @type {Notes}
     * @memberof AssetReminderReturnType
     */
    'notes'?: Notes;
}
/**
 * 
 * @export
 * @interface AssetResponse
 */
export interface AssetResponse {
    /**
     * 
     * @type {Asset}
     * @memberof AssetResponse
     */
    'asset': Asset;
    /**
     * 
     * @type {string}
     * @memberof AssetResponse
     */
    'complaint': string;
    /**
     * 
     * @type {AssetResponseMostRecentValidation}
     * @memberof AssetResponse
     */
    'most_recent_validation': AssetResponseMostRecentValidation;
}
/**
 * 
 * @export
 * @interface AssetResponseMostRecentValidation
 */
export interface AssetResponseMostRecentValidation {
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'id': any;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'tenant_id': any;
    /**
     * 
     * @type {AssetId}
     * @memberof AssetResponseMostRecentValidation
     */
    'asset_id': AssetId;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'original_filename': any;
    /**
     * 
     * @type {FileHash}
     * @memberof AssetResponseMostRecentValidation
     */
    'file_hash': FileHash;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'outcome': any;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'original_outcome': any;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'created': any;
    /**
     * 
     * @type {InspectionDate}
     * @memberof AssetResponseMostRecentValidation
     */
    'inspection_date': InspectionDate;
    /**
     * 
     * @type {EngineerName}
     * @memberof AssetResponseMostRecentValidation
     */
    'engineer_name': EngineerName;
    /**
     * 
     * @type {NextInspectionDue}
     * @memberof AssetResponseMostRecentValidation
     */
    'next_inspection_due': NextInspectionDue;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'site_address_line_1': any;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'site_address_line_2': any;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'site_address_town_city': any;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'site_address_county': any;
    /**
     * 
     * @type {any}
     * @memberof AssetResponseMostRecentValidation
     */
    'site_address_postcode': any;
    /**
     * 
     * @type {ContractorId}
     * @memberof AssetResponseMostRecentValidation
     */
    'contractor_id'?: ContractorId;
}
/**
 * 
 * @export
 * @interface ClientId
 */
export interface ClientId {
}
/**
 * 
 * @export
 * @interface ClientSecret
 */
export interface ClientSecret {
}
/**
 * 
 * @export
 * @interface Contractor
 */
export interface Contractor {
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    'tenant_id': string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    'date_added': string;
    /**
     * 
     * @type {Notes}
     * @memberof Contractor
     */
    'notes'?: Notes;
}
/**
 * 
 * @export
 * @interface ContractorCreate
 */
export interface ContractorCreate {
    /**
     * 
     * @type {string}
     * @memberof ContractorCreate
     */
    'name': string;
    /**
     * 
     * @type {Notes}
     * @memberof ContractorCreate
     */
    'notes'?: Notes;
}
/**
 * 
 * @export
 * @interface ContractorId
 */
export interface ContractorId {
}
/**
 * 
 * @export
 * @interface ContractorName
 */
export interface ContractorName {
}
/**
 * 
 * @export
 * @interface DefectIndex
 */
export interface DefectIndex {
}
/**
 * 
 * @export
 * @interface DocumentAIAnalysis
 */
export interface DocumentAIAnalysis {
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'tenant_id': string;
    /**
     * 
     * @type {AssetId}
     * @memberof DocumentAIAnalysis
     */
    'asset_id': AssetId;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'original_filename': string;
    /**
     * 
     * @type {FileHash}
     * @memberof DocumentAIAnalysis
     */
    'file_hash': FileHash;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'outcome': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'original_outcome': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'created': string;
    /**
     * 
     * @type {InspectionDate}
     * @memberof DocumentAIAnalysis
     */
    'inspection_date': InspectionDate;
    /**
     * 
     * @type {EngineerName}
     * @memberof DocumentAIAnalysis
     */
    'engineer_name': EngineerName;
    /**
     * 
     * @type {NextInspectionDue}
     * @memberof DocumentAIAnalysis
     */
    'next_inspection_due': NextInspectionDue;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'site_address_line_1': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'site_address_line_2': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'site_address_town_city': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'site_address_county': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    'site_address_postcode': string;
    /**
     * 
     * @type {ContractorId}
     * @memberof DocumentAIAnalysis
     */
    'contractor_id'?: ContractorId;
}
/**
 * 
 * @export
 * @interface DocumentAIAnalysisResponse
 */
export interface DocumentAIAnalysisResponse {
    /**
     * 
     * @type {DocumentAIAnalysis}
     * @memberof DocumentAIAnalysisResponse
     */
    'analysis': DocumentAIAnalysis;
    /**
     * 
     * @type {Array<HydratedDocumentAuditEvent>}
     * @memberof DocumentAIAnalysisResponse
     */
    'audit_events'?: Array<HydratedDocumentAuditEvent>;
}
/**
 * 
 * @export
 * @interface DocumentAppliance
 */
export interface DocumentAppliance {
    /**
     * 
     * @type {string}
     * @memberof DocumentAppliance
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAppliance
     */
    'document_analysis_id': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentAppliance
     */
    'appliance_index': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentAppliance
     */
    'appliance_location': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAppliance
     */
    'appliance_type': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAppliance
     */
    'appliance_make': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAppliance
     */
    'appliance_model': string;
}
/**
 * 
 * @export
 * @interface DocumentAuditEvent
 */
export interface DocumentAuditEvent {
    /**
     * 
     * @type {string}
     * @memberof DocumentAuditEvent
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAuditEvent
     */
    'document_analysis_id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAuditEvent
     */
    'audit_description': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAuditEvent
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAuditEvent
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface DocumentDefect
 */
export interface DocumentDefect {
    /**
     * 
     * @type {string}
     * @memberof DocumentDefect
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDefect
     */
    'document_analysis_id': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentDefect
     */
    'defect_index': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDefect
     */
    'defect': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDefect
     */
    'remedial_action': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDefect
     */
    'notice_issued': string;
}
/**
 * 
 * @export
 * @interface DocumentLocation
 */
export interface DocumentLocation {
    /**
     * 
     * @type {number}
     * @memberof DocumentLocation
     */
    'page_number': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DocumentLocation
     */
    'polygon': Array<number>;
}
/**
 * 
 * @export
 * @interface EmailDetails
 */
export interface EmailDetails {
    /**
     * 
     * @type {string}
     * @memberof EmailDetails
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EmailDetails
     */
    'contact_email': string;
    /**
     * 
     * @type {string}
     * @memberof EmailDetails
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof EmailDetails
     */
    'g_recaptcha_response': string;
}
/**
 * 
 * @export
 * @interface EngineerName
 */
export interface EngineerName {
}
/**
 * 
 * @export
 * @interface ErrorMessage
 */
export interface ErrorMessage {
}
/**
 * 
 * @export
 * @interface Expiry
 */
export interface Expiry {
}
/**
 * 
 * @export
 * @interface FileHash
 */
export interface FileHash {
}
/**
 * 
 * @export
 * @interface FirstName
 */
export interface FirstName {
}
/**
 * 
 * @export
 * @interface GrantType
 */
export interface GrantType {
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface HydratedAssetAuditEvent
 */
export interface HydratedAssetAuditEvent {
    /**
     * 
     * @type {AssetAuditEvent}
     * @memberof HydratedAssetAuditEvent
     */
    'asset_audit_event': AssetAuditEvent;
    /**
     * 
     * @type {string}
     * @memberof HydratedAssetAuditEvent
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof HydratedAssetAuditEvent
     */
    'user_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof HydratedAssetAuditEvent
     */
    'user_last_name': string;
}
/**
 * 
 * @export
 * @interface HydratedDocumentAuditEvent
 */
export interface HydratedDocumentAuditEvent {
    /**
     * 
     * @type {DocumentAuditEvent}
     * @memberof HydratedDocumentAuditEvent
     */
    'document_audit_event': DocumentAuditEvent;
    /**
     * 
     * @type {string}
     * @memberof HydratedDocumentAuditEvent
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof HydratedDocumentAuditEvent
     */
    'user_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof HydratedDocumentAuditEvent
     */
    'user_last_name': string;
}
/**
 * 
 * @export
 * @interface InspectionDate
 */
export interface InspectionDate {
}
/**
 * 
 * @export
 * @interface JobResponse
 */
export interface JobResponse {
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    'id': string;
    /**
     * 
     * @type {JobStatus}
     * @memberof JobResponse
     */
    'status': JobStatus;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    'original_filename': string;
    /**
     * 
     * @type {ErrorMessage}
     * @memberof JobResponse
     */
    'error_message'?: ErrorMessage;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const JobStatus = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];


/**
 * 
 * @export
 * @interface LastName
 */
export interface LastName {
}
/**
 * 
 * @export
 * @interface MeResponse
 */
export interface MeResponse {
    /**
     * 
     * @type {string}
     * @memberof MeResponse
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof MeResponse
     */
    'last_name': string;
    /**
     * 
     * @type {Array<Tenant>}
     * @memberof MeResponse
     */
    'tenants': Array<Tenant>;
}
/**
 * 
 * @export
 * @interface NewPassword
 */
export interface NewPassword {
}
/**
 * 
 * @export
 * @interface NewUserRequest
 */
export interface NewUserRequest {
    /**
     * 
     * @type {string}
     * @memberof NewUserRequest
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof NewUserRequest
     */
    'user_management': boolean;
}
/**
 * 
 * @export
 * @interface NextInspectionDue
 */
export interface NextInspectionDue {
}
/**
 * 
 * @export
 * @interface Notes
 */
export interface Notes {
}
/**
 * 
 * @export
 * @interface OSAddressResponse
 */
export interface OSAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof OSAddressResponse
     */
    'address_1': string;
    /**
     * 
     * @type {Address2}
     * @memberof OSAddressResponse
     */
    'address_2': Address2;
    /**
     * 
     * @type {string}
     * @memberof OSAddressResponse
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof OSAddressResponse
     */
    'county': string;
    /**
     * 
     * @type {string}
     * @memberof OSAddressResponse
     */
    'postcode': string;
    /**
     * 
     * @type {string}
     * @memberof OSAddressResponse
     */
    'UPRN': string;
}
/**
 * 
 * @export
 * @interface OldPassword
 */
export interface OldPassword {
}
/**
 * 
 * @export
 * @interface OriginalReason
 */
export interface OriginalReason {
}
/**
 * 
 * @export
 * @interface OverriddenAt
 */
export interface OverriddenAt {
}
/**
 * 
 * @export
 * @interface OverriddenBy
 */
export interface OverriddenBy {
}
/**
 * 
 * @export
 * @interface OverriddenReason
 */
export interface OverriddenReason {
}
/**
 * 
 * @export
 * @interface PendingRegistrationResponse
 */
export interface PendingRegistrationResponse {
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PendingRegistrationResponse
     */
    'expiry': string;
}
/**
 * 
 * @export
 * @interface RegisterUserRequest
 */
export interface RegisterUserRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'registration_id': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'registration_secret': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ReminderDueSoonResponseType
 */
export interface ReminderDueSoonResponseType {
    /**
     * 
     * @type {string}
     * @memberof ReminderDueSoonResponseType
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderDueSoonResponseType
     */
    'asset_id': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderDueSoonResponseType
     */
    'reminder_type': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderDueSoonResponseType
     */
    'reminder_date': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderDueSoonResponseType
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderDueSoonResponseType
     */
    'created_by_username': string;
    /**
     * 
     * @type {Notes}
     * @memberof ReminderDueSoonResponseType
     */
    'notes'?: Notes;
    /**
     * 
     * @type {string}
     * @memberof ReminderDueSoonResponseType
     */
    'asset_address': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'reset_id': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'reset_secret': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface Tenant
 */
export interface Tenant {
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof Tenant
     */
    'feature_flag_contractors'?: boolean;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'token_type': string;
}
/**
 * 
 * @export
 * @interface UpdateUserDetailsRequest
 */
export interface UpdateUserDetailsRequest {
    /**
     * 
     * @type {FirstName}
     * @memberof UpdateUserDetailsRequest
     */
    'first_name'?: FirstName;
    /**
     * 
     * @type {LastName}
     * @memberof UpdateUserDetailsRequest
     */
    'last_name'?: LastName;
    /**
     * 
     * @type {OldPassword}
     * @memberof UpdateUserDetailsRequest
     */
    'old_password'?: OldPassword;
    /**
     * 
     * @type {NewPassword}
     * @memberof UpdateUserDetailsRequest
     */
    'new_password'?: NewPassword;
}
/**
 * 
 * @export
 * @interface UserResp
 */
export interface UserResp {
    /**
     * 
     * @type {Array<UserTenantInfo>}
     * @memberof UserResp
     */
    'users': Array<UserTenantInfo>;
}
/**
 * 
 * @export
 * @interface UserTenantInfo
 */
export interface UserTenantInfo {
    /**
     * 
     * @type {string}
     * @memberof UserTenantInfo
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserTenantInfo
     */
    'tenant_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserTenantInfo
     */
    'user_management': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserTenantInfo
     */
    'user_disabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserTenantInfo
     */
    'receive_reminders': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserTenantInfo
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserTenantInfo
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserTenantInfo
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * 
 * @export
 * @interface ValidationsResponse
 */
export interface ValidationsResponse {
    /**
     * 
     * @type {Array<AIVerificationResult>}
     * @memberof ValidationsResponse
     */
    'validations': Array<AIVerificationResult>;
    /**
     * 
     * @type {Array<DocumentAppliance>}
     * @memberof ValidationsResponse
     */
    'appliances': Array<DocumentAppliance>;
    /**
     * 
     * @type {Array<DocumentDefect>}
     * @memberof ValidationsResponse
     */
    'defects': Array<DocumentDefect>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ValidationsResponse
     */
    'user_mapping': { [key: string]: string; };
}

/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Asset And Associate Analysis
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetAndAssociateAnalysisAssetsPost: async (address1: string, address2: string, city: string, county: string, postcode: string, analysisId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'address1' is not null or undefined
            assertParamExists('createAssetAndAssociateAnalysisAssetsPost', 'address1', address1)
            // verify required parameter 'address2' is not null or undefined
            assertParamExists('createAssetAndAssociateAnalysisAssetsPost', 'address2', address2)
            // verify required parameter 'city' is not null or undefined
            assertParamExists('createAssetAndAssociateAnalysisAssetsPost', 'city', city)
            // verify required parameter 'county' is not null or undefined
            assertParamExists('createAssetAndAssociateAnalysisAssetsPost', 'county', county)
            // verify required parameter 'postcode' is not null or undefined
            assertParamExists('createAssetAndAssociateAnalysisAssetsPost', 'postcode', postcode)
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('createAssetAndAssociateAnalysisAssetsPost', 'analysisId', analysisId)
            const localVarPath = `/assets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (address1 !== undefined) {
                localVarQueryParameter['address_1'] = address1;
            }

            if (address2 !== undefined) {
                localVarQueryParameter['address_2'] = address2;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (county !== undefined) {
                localVarQueryParameter['county'] = county;
            }

            if (postcode !== undefined) {
                localVarQueryParameter['postcode'] = postcode;
            }

            if (analysisId !== undefined) {
                localVarQueryParameter['analysis_id'] = analysisId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Asset
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetAssetsNewPost: async (address1: string, address2: string, city: string, county: string, postcode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'address1' is not null or undefined
            assertParamExists('createAssetAssetsNewPost', 'address1', address1)
            // verify required parameter 'address2' is not null or undefined
            assertParamExists('createAssetAssetsNewPost', 'address2', address2)
            // verify required parameter 'city' is not null or undefined
            assertParamExists('createAssetAssetsNewPost', 'city', city)
            // verify required parameter 'county' is not null or undefined
            assertParamExists('createAssetAssetsNewPost', 'county', county)
            // verify required parameter 'postcode' is not null or undefined
            assertParamExists('createAssetAssetsNewPost', 'postcode', postcode)
            const localVarPath = `/assets/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (address1 !== undefined) {
                localVarQueryParameter['address_1'] = address1;
            }

            if (address2 !== undefined) {
                localVarQueryParameter['address_2'] = address2;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (county !== undefined) {
                localVarQueryParameter['county'] = county;
            }

            if (postcode !== undefined) {
                localVarQueryParameter['postcode'] = postcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Asset Reminder
         * @param {string} assetId 
         * @param {string} reminderType 
         * @param {string} reminderDate 
         * @param {string} notes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetReminderAssetsAssetIdRemindersPost: async (assetId: string, reminderType: string, reminderDate: string, notes: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('createAssetReminderAssetsAssetIdRemindersPost', 'assetId', assetId)
            // verify required parameter 'reminderType' is not null or undefined
            assertParamExists('createAssetReminderAssetsAssetIdRemindersPost', 'reminderType', reminderType)
            // verify required parameter 'reminderDate' is not null or undefined
            assertParamExists('createAssetReminderAssetsAssetIdRemindersPost', 'reminderDate', reminderDate)
            // verify required parameter 'notes' is not null or undefined
            assertParamExists('createAssetReminderAssetsAssetIdRemindersPost', 'notes', notes)
            const localVarPath = `/assets/{asset_id}/reminders`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reminderType !== undefined) {
                localVarQueryParameter['reminder_type'] = reminderType;
            }

            if (reminderDate !== undefined) {
                localVarQueryParameter['reminder_date'] = (reminderDate as any instanceof Date) ?
                    (reminderDate as any).toISOString() :
                    reminderDate;
            }

            if (notes !== undefined) {
                localVarQueryParameter['notes'] = notes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Asset
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetAssetsAssetIdDelete: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteAssetAssetsAssetIdDelete', 'assetId', assetId)
            const localVarPath = `/assets/{asset_id}`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Asset Document
         * @param {string} assetId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete: async (assetId: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete', 'assetId', assetId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete', 'documentId', documentId)
            const localVarPath = `/assets/{asset_id}/documents/{document_id}`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)))
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Asset Reminder
         * @param {string} assetId 
         * @param {string} reminderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete: async (assetId: string, reminderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete', 'assetId', assetId)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete', 'reminderId', reminderId)
            const localVarPath = `/assets/{asset_id}/reminders/{reminder_id}`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)))
                .replace(`{${"reminder_id"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download Asset Document
         * @param {string} assetId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet: async (assetId: string, documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet', 'assetId', assetId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet', 'documentId', documentId)
            const localVarPath = `/assets/{asset_id}/documents/{document_id}/download`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)))
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Asset Analyses
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetAnalysesAssetsAssetIdAnalysesGet: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getAssetAnalysesAssetsAssetIdAnalysesGet', 'assetId', assetId)
            const localVarPath = `/assets/{asset_id}/analyses`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Asset Audit Events
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetAuditEventsAssetsAssetIdAuditEventsGet: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getAssetAuditEventsAssetsAssetIdAuditEventsGet', 'assetId', assetId)
            const localVarPath = `/assets/{asset_id}/audit_events`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Asset By Address
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetByAddressAssetsByAddressGet: async (address1: string, address2: string, city: string, county: string, postcode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'address1' is not null or undefined
            assertParamExists('getAssetByAddressAssetsByAddressGet', 'address1', address1)
            // verify required parameter 'address2' is not null or undefined
            assertParamExists('getAssetByAddressAssetsByAddressGet', 'address2', address2)
            // verify required parameter 'city' is not null or undefined
            assertParamExists('getAssetByAddressAssetsByAddressGet', 'city', city)
            // verify required parameter 'county' is not null or undefined
            assertParamExists('getAssetByAddressAssetsByAddressGet', 'county', county)
            // verify required parameter 'postcode' is not null or undefined
            assertParamExists('getAssetByAddressAssetsByAddressGet', 'postcode', postcode)
            const localVarPath = `/assets/by_address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (address1 !== undefined) {
                localVarQueryParameter['address_1'] = address1;
            }

            if (address2 !== undefined) {
                localVarQueryParameter['address_2'] = address2;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (county !== undefined) {
                localVarQueryParameter['county'] = county;
            }

            if (postcode !== undefined) {
                localVarQueryParameter['postcode'] = postcode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Asset Documents
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetDocumentsAssetsAssetIdDocumentsGet: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getAssetDocumentsAssetsAssetIdDocumentsGet', 'assetId', assetId)
            const localVarPath = `/assets/{asset_id}/documents`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Asset Reminders
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetRemindersAssetsAssetIdRemindersGet: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getAssetRemindersAssetsAssetIdRemindersGet', 'assetId', assetId)
            const localVarPath = `/assets/{asset_id}/reminders`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetsAssetsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Due Soon Reminders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDueSoonRemindersAssetsRemindersDueSoonGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assets/reminders/due_soon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Asset Document
         * @param {string} assetId 
         * @param {string} documentName 
         * @param {string} documentType 
         * @param {string} filename 
         * @param {string} expiry 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAssetDocumentAssetsAssetIdDocumentsPost: async (assetId: string, documentName: string, documentType: string, filename: string, expiry: string, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('uploadAssetDocumentAssetsAssetIdDocumentsPost', 'assetId', assetId)
            // verify required parameter 'documentName' is not null or undefined
            assertParamExists('uploadAssetDocumentAssetsAssetIdDocumentsPost', 'documentName', documentName)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('uploadAssetDocumentAssetsAssetIdDocumentsPost', 'documentType', documentType)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('uploadAssetDocumentAssetsAssetIdDocumentsPost', 'filename', filename)
            // verify required parameter 'expiry' is not null or undefined
            assertParamExists('uploadAssetDocumentAssetsAssetIdDocumentsPost', 'expiry', expiry)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadAssetDocumentAssetsAssetIdDocumentsPost', 'files', files)
            const localVarPath = `/assets/{asset_id}/documents`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (documentName !== undefined) {
                localVarQueryParameter['document_name'] = documentName;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['document_type'] = documentType;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }

            if (expiry !== undefined) {
                localVarQueryParameter['expiry'] = expiry;
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Asset And Associate Analysis
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssetAndAssociateAnalysisAssetsPost(address1: string, address2: string, city: string, county: string, postcode: string, analysisId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssetAndAssociateAnalysisAssetsPost(address1, address2, city, county, postcode, analysisId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.createAssetAndAssociateAnalysisAssetsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Asset
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssetAssetsNewPost(address1: string, address2: string, city: string, county: string, postcode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Asset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssetAssetsNewPost(address1, address2, city, county, postcode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.createAssetAssetsNewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Asset Reminder
         * @param {string} assetId 
         * @param {string} reminderType 
         * @param {string} reminderDate 
         * @param {string} notes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssetReminderAssetsAssetIdRemindersPost(assetId: string, reminderType: string, reminderDate: string, notes: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssetReminderAssetsAssetIdRemindersPost(assetId, reminderType, reminderDate, notes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.createAssetReminderAssetsAssetIdRemindersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Asset
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssetAssetsAssetIdDelete(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssetAssetsAssetIdDelete(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.deleteAssetAssetsAssetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Asset Document
         * @param {string} assetId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete(assetId: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete(assetId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Asset Reminder
         * @param {string} assetId 
         * @param {string} reminderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete(assetId: string, reminderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete(assetId, reminderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download Asset Document
         * @param {string} assetId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet(assetId: string, documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet(assetId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Asset Analyses
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetAnalysesAssetsAssetIdAnalysesGet(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentAIAnalysis>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetAnalysesAssetsAssetIdAnalysesGet(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.getAssetAnalysesAssetsAssetIdAnalysesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Asset Audit Events
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetAuditEventsAssetsAssetIdAuditEventsGet(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HydratedAssetAuditEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetAuditEventsAssetsAssetIdAuditEventsGet(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.getAssetAuditEventsAssetsAssetIdAuditEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Asset By Address
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetByAddressAssetsByAddressGet(address1: string, address2: string, city: string, county: string, postcode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetByAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetByAddressAssetsByAddressGet(address1, address2, city, county, postcode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.getAssetByAddressAssetsByAddressGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Asset Documents
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetDocumentsAssetsAssetIdDocumentsGet(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetDocumentReturnType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetDocumentsAssetsAssetIdDocumentsGet(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.getAssetDocumentsAssetsAssetIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Asset Reminders
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetRemindersAssetsAssetIdRemindersGet(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetReminderReturnType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetRemindersAssetsAssetIdRemindersGet(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.getAssetRemindersAssetsAssetIdRemindersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssetsAssetsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetsAssetsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.getAssetsAssetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Due Soon Reminders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDueSoonRemindersAssetsRemindersDueSoonGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReminderDueSoonResponseType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDueSoonRemindersAssetsRemindersDueSoonGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.getDueSoonRemindersAssetsRemindersDueSoonGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Asset Document
         * @param {string} assetId 
         * @param {string} documentName 
         * @param {string} documentType 
         * @param {string} filename 
         * @param {string} expiry 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAssetDocumentAssetsAssetIdDocumentsPost(assetId: string, documentName: string, documentType: string, filename: string, expiry: string, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAssetDocumentAssetsAssetIdDocumentsPost(assetId, documentName, documentType, filename, expiry, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetsApi.uploadAssetDocumentAssetsAssetIdDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Asset And Associate Analysis
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetAndAssociateAnalysisAssetsPost(address1: string, address2: string, city: string, county: string, postcode: string, analysisId: string, options?: any): AxiosPromise<any> {
            return localVarFp.createAssetAndAssociateAnalysisAssetsPost(address1, address2, city, county, postcode, analysisId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Asset
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetAssetsNewPost(address1: string, address2: string, city: string, county: string, postcode: string, options?: any): AxiosPromise<Asset> {
            return localVarFp.createAssetAssetsNewPost(address1, address2, city, county, postcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Asset Reminder
         * @param {string} assetId 
         * @param {string} reminderType 
         * @param {string} reminderDate 
         * @param {string} notes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssetReminderAssetsAssetIdRemindersPost(assetId: string, reminderType: string, reminderDate: string, notes: string, options?: any): AxiosPromise<any> {
            return localVarFp.createAssetReminderAssetsAssetIdRemindersPost(assetId, reminderType, reminderDate, notes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Asset
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetAssetsAssetIdDelete(assetId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteAssetAssetsAssetIdDelete(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Asset Document
         * @param {string} assetId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete(assetId: string, documentId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete(assetId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Asset Reminder
         * @param {string} assetId 
         * @param {string} reminderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete(assetId: string, reminderId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete(assetId, reminderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download Asset Document
         * @param {string} assetId 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet(assetId: string, documentId: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet(assetId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Asset Analyses
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetAnalysesAssetsAssetIdAnalysesGet(assetId: string, options?: any): AxiosPromise<Array<DocumentAIAnalysis>> {
            return localVarFp.getAssetAnalysesAssetsAssetIdAnalysesGet(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Asset Audit Events
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetAuditEventsAssetsAssetIdAuditEventsGet(assetId: string, options?: any): AxiosPromise<Array<HydratedAssetAuditEvent>> {
            return localVarFp.getAssetAuditEventsAssetsAssetIdAuditEventsGet(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Asset By Address
         * @param {string} address1 
         * @param {string} address2 
         * @param {string} city 
         * @param {string} county 
         * @param {string} postcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetByAddressAssetsByAddressGet(address1: string, address2: string, city: string, county: string, postcode: string, options?: any): AxiosPromise<AssetByAddressResponse> {
            return localVarFp.getAssetByAddressAssetsByAddressGet(address1, address2, city, county, postcode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Asset Documents
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetDocumentsAssetsAssetIdDocumentsGet(assetId: string, options?: any): AxiosPromise<Array<AssetDocumentReturnType>> {
            return localVarFp.getAssetDocumentsAssetsAssetIdDocumentsGet(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Asset Reminders
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetRemindersAssetsAssetIdRemindersGet(assetId: string, options?: any): AxiosPromise<Array<AssetReminderReturnType>> {
            return localVarFp.getAssetRemindersAssetsAssetIdRemindersGet(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Assets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetsAssetsGet(options?: any): AxiosPromise<Array<AssetResponse>> {
            return localVarFp.getAssetsAssetsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Due Soon Reminders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDueSoonRemindersAssetsRemindersDueSoonGet(options?: any): AxiosPromise<Array<ReminderDueSoonResponseType>> {
            return localVarFp.getDueSoonRemindersAssetsRemindersDueSoonGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Asset Document
         * @param {string} assetId 
         * @param {string} documentName 
         * @param {string} documentType 
         * @param {string} filename 
         * @param {string} expiry 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAssetDocumentAssetsAssetIdDocumentsPost(assetId: string, documentName: string, documentType: string, filename: string, expiry: string, files: Array<File>, options?: any): AxiosPromise<any> {
            return localVarFp.uploadAssetDocumentAssetsAssetIdDocumentsPost(assetId, documentName, documentType, filename, expiry, files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI {
    /**
     * 
     * @summary Create Asset And Associate Analysis
     * @param {string} address1 
     * @param {string} address2 
     * @param {string} city 
     * @param {string} county 
     * @param {string} postcode 
     * @param {string} analysisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public createAssetAndAssociateAnalysisAssetsPost(address1: string, address2: string, city: string, county: string, postcode: string, analysisId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).createAssetAndAssociateAnalysisAssetsPost(address1, address2, city, county, postcode, analysisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Asset
     * @param {string} address1 
     * @param {string} address2 
     * @param {string} city 
     * @param {string} county 
     * @param {string} postcode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public createAssetAssetsNewPost(address1: string, address2: string, city: string, county: string, postcode: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).createAssetAssetsNewPost(address1, address2, city, county, postcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Asset Reminder
     * @param {string} assetId 
     * @param {string} reminderType 
     * @param {string} reminderDate 
     * @param {string} notes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public createAssetReminderAssetsAssetIdRemindersPost(assetId: string, reminderType: string, reminderDate: string, notes: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).createAssetReminderAssetsAssetIdRemindersPost(assetId, reminderType, reminderDate, notes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Asset
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public deleteAssetAssetsAssetIdDelete(assetId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).deleteAssetAssetsAssetIdDelete(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Asset Document
     * @param {string} assetId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete(assetId: string, documentId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).deleteAssetDocumentAssetsAssetIdDocumentsDocumentIdDelete(assetId, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Asset Reminder
     * @param {string} assetId 
     * @param {string} reminderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete(assetId: string, reminderId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).deleteAssetReminderAssetsAssetIdRemindersReminderIdDelete(assetId, reminderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download Asset Document
     * @param {string} assetId 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet(assetId: string, documentId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).downloadAssetDocumentAssetsAssetIdDocumentsDocumentIdDownloadGet(assetId, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Asset Analyses
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public getAssetAnalysesAssetsAssetIdAnalysesGet(assetId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).getAssetAnalysesAssetsAssetIdAnalysesGet(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Asset Audit Events
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public getAssetAuditEventsAssetsAssetIdAuditEventsGet(assetId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).getAssetAuditEventsAssetsAssetIdAuditEventsGet(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Asset By Address
     * @param {string} address1 
     * @param {string} address2 
     * @param {string} city 
     * @param {string} county 
     * @param {string} postcode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public getAssetByAddressAssetsByAddressGet(address1: string, address2: string, city: string, county: string, postcode: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).getAssetByAddressAssetsByAddressGet(address1, address2, city, county, postcode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Asset Documents
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public getAssetDocumentsAssetsAssetIdDocumentsGet(assetId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).getAssetDocumentsAssetsAssetIdDocumentsGet(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Asset Reminders
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public getAssetRemindersAssetsAssetIdRemindersGet(assetId: string, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).getAssetRemindersAssetsAssetIdRemindersGet(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public getAssetsAssetsGet(options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).getAssetsAssetsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Due Soon Reminders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public getDueSoonRemindersAssetsRemindersDueSoonGet(options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).getDueSoonRemindersAssetsRemindersDueSoonGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Asset Document
     * @param {string} assetId 
     * @param {string} documentName 
     * @param {string} documentType 
     * @param {string} filename 
     * @param {string} expiry 
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public uploadAssetDocumentAssetsAssetIdDocumentsPost(assetId: string, documentName: string, documentType: string, filename: string, expiry: string, files: Array<File>, options?: RawAxiosRequestConfig) {
        return AssetsApiFp(this.configuration).uploadAssetDocumentAssetsAssetIdDocumentsPost(assetId, documentName, documentType, filename, expiry, files, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractorsApi - axios parameter creator
 * @export
 */
export const ContractorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Contractor
         * @param {ContractorCreate} contractorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractorContractorsPost: async (contractorCreate: ContractorCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorCreate' is not null or undefined
            assertParamExists('createContractorContractorsPost', 'contractorCreate', contractorCreate)
            const localVarPath = `/contractors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Contractor
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractorContractorsContractorIdDelete: async (contractorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('deleteContractorContractorsContractorIdDelete', 'contractorId', contractorId)
            const localVarPath = `/contractors/{contractor_id}`
                .replace(`{${"contractor_id"}}`, encodeURIComponent(String(contractorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Contractor Analyses
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorAnalysesContractorsContractorIdAnalysesGet: async (contractorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('getContractorAnalysesContractorsContractorIdAnalysesGet', 'contractorId', contractorId)
            const localVarPath = `/contractors/{contractor_id}/analyses`
                .replace(`{${"contractor_id"}}`, encodeURIComponent(String(contractorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Contractor
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorContractorsContractorIdGet: async (contractorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('getContractorContractorsContractorIdGet', 'contractorId', contractorId)
            const localVarPath = `/contractors/{contractor_id}`
                .replace(`{${"contractor_id"}}`, encodeURIComponent(String(contractorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Contractors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorsContractorsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contractors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Contractor
         * @param {string} contractorId 
         * @param {ContractorCreate} contractorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContractorContractorsContractorIdPatch: async (contractorId: string, contractorCreate: ContractorCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('updateContractorContractorsContractorIdPatch', 'contractorId', contractorId)
            // verify required parameter 'contractorCreate' is not null or undefined
            assertParamExists('updateContractorContractorsContractorIdPatch', 'contractorCreate', contractorCreate)
            const localVarPath = `/contractors/{contractor_id}`
                .replace(`{${"contractor_id"}}`, encodeURIComponent(String(contractorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorsApi - functional programming interface
 * @export
 */
export const ContractorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Contractor
         * @param {ContractorCreate} contractorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContractorContractorsPost(contractorCreate: ContractorCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contractor>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContractorContractorsPost(contractorCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorsApi.createContractorContractorsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Contractor
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContractorContractorsContractorIdDelete(contractorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContractorContractorsContractorIdDelete(contractorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorsApi.deleteContractorContractorsContractorIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Contractor Analyses
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractorAnalysesContractorsContractorIdAnalysesGet(contractorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalysisResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractorAnalysesContractorsContractorIdAnalysesGet(contractorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorsApi.getContractorAnalysesContractorsContractorIdAnalysesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Contractor
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractorContractorsContractorIdGet(contractorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contractor>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractorContractorsContractorIdGet(contractorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorsApi.getContractorContractorsContractorIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Contractors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractorsContractorsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Contractor>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractorsContractorsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorsApi.getContractorsContractorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Contractor
         * @param {string} contractorId 
         * @param {ContractorCreate} contractorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContractorContractorsContractorIdPatch(contractorId: string, contractorCreate: ContractorCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contractor>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContractorContractorsContractorIdPatch(contractorId, contractorCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorsApi.updateContractorContractorsContractorIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractorsApi - factory interface
 * @export
 */
export const ContractorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Contractor
         * @param {ContractorCreate} contractorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractorContractorsPost(contractorCreate: ContractorCreate, options?: any): AxiosPromise<Contractor> {
            return localVarFp.createContractorContractorsPost(contractorCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Contractor
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractorContractorsContractorIdDelete(contractorId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteContractorContractorsContractorIdDelete(contractorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Contractor Analyses
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorAnalysesContractorsContractorIdAnalysesGet(contractorId: string, options?: any): AxiosPromise<Array<AnalysisResponse>> {
            return localVarFp.getContractorAnalysesContractorsContractorIdAnalysesGet(contractorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Contractor
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorContractorsContractorIdGet(contractorId: string, options?: any): AxiosPromise<Contractor> {
            return localVarFp.getContractorContractorsContractorIdGet(contractorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Contractors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorsContractorsGet(options?: any): AxiosPromise<Array<Contractor>> {
            return localVarFp.getContractorsContractorsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Contractor
         * @param {string} contractorId 
         * @param {ContractorCreate} contractorCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContractorContractorsContractorIdPatch(contractorId: string, contractorCreate: ContractorCreate, options?: any): AxiosPromise<Contractor> {
            return localVarFp.updateContractorContractorsContractorIdPatch(contractorId, contractorCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractorsApi - object-oriented interface
 * @export
 * @class ContractorsApi
 * @extends {BaseAPI}
 */
export class ContractorsApi extends BaseAPI {
    /**
     * 
     * @summary Create Contractor
     * @param {ContractorCreate} contractorCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public createContractorContractorsPost(contractorCreate: ContractorCreate, options?: RawAxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).createContractorContractorsPost(contractorCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Contractor
     * @param {string} contractorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public deleteContractorContractorsContractorIdDelete(contractorId: string, options?: RawAxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).deleteContractorContractorsContractorIdDelete(contractorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Contractor Analyses
     * @param {string} contractorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public getContractorAnalysesContractorsContractorIdAnalysesGet(contractorId: string, options?: RawAxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).getContractorAnalysesContractorsContractorIdAnalysesGet(contractorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Contractor
     * @param {string} contractorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public getContractorContractorsContractorIdGet(contractorId: string, options?: RawAxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).getContractorContractorsContractorIdGet(contractorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Contractors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public getContractorsContractorsGet(options?: RawAxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).getContractorsContractorsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Contractor
     * @param {string} contractorId 
     * @param {ContractorCreate} contractorCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public updateContractorContractorsContractorIdPatch(contractorId: string, contractorCreate: ContractorCreate, options?: RawAxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).updateContractorContractorsContractorIdPatch(contractorId, contractorCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Password Reset
         * @param {string} id 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordResetResetPasswordIdSecretGet: async (id: string, secret: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPasswordResetResetPasswordIdSecretGet', 'id', id)
            // verify required parameter 'secret' is not null or undefined
            assertParamExists('getPasswordResetResetPasswordIdSecretGet', 'secret', secret)
            const localVarPath = `/reset_password/{id}/{secret}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"secret"}}`, encodeURIComponent(String(secret)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pending Registration
         * @param {string} id 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingRegistrationPendingRegistrationIdSecretGet: async (id: string, secret: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPendingRegistrationPendingRegistrationIdSecretGet', 'id', id)
            // verify required parameter 'secret' is not null or undefined
            assertParamExists('getPendingRegistrationPendingRegistrationIdSecretGet', 'secret', secret)
            const localVarPath = `/pending_registration/{id}/{secret}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"secret"}}`, encodeURIComponent(String(secret)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login For Access Token
         * @param {string} username 
         * @param {string} password 
         * @param {GrantType} [grantType] 
         * @param {string} [scope] 
         * @param {ClientId} [clientId] 
         * @param {ClientSecret} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginForAccessTokenTokenPost: async (username: string, password: string, grantType?: GrantType, scope?: string, clientId?: ClientId, clientSecret?: ClientSecret, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('loginForAccessTokenTokenPost', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('loginForAccessTokenTokenPost', 'password', password)
            const localVarPath = `/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (grantType !== undefined) { 
                localVarFormParams.set('grant_type', grantType as any);
            }
    
            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (scope !== undefined) { 
                localVarFormParams.set('scope', scope as any);
            }
    
            if (clientId !== undefined) { 
                localVarFormParams.set('client_id', clientId as any);
            }
    
            if (clientSecret !== undefined) { 
                localVarFormParams.set('client_secret', clientSecret as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read Users Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUsersMeMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register User
         * @param {RegisterUserRequest} registerUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUserRegisterPost: async (registerUserRequest: RegisterUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerUserRequest' is not null or undefined
            assertParamExists('registerUserRegisterPost', 'registerUserRequest', registerUserRequest)
            const localVarPath = `/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordResetPasswordPost: async (resetPasswordRequest: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('resetPasswordResetPasswordPost', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/reset_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Email
         * @param {EmailDetails} emailDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailSendEmailPost: async (emailDetails: EmailDetails, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailDetails' is not null or undefined
            assertParamExists('sendEmailSendEmailPost', 'emailDetails', emailDetails)
            const localVarPath = `/send-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Password Reset
         * @param {string} id 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordResetResetPasswordIdSecretGet(id: string, secret: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswordResetResetPasswordIdSecretGet(id, secret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPasswordResetResetPasswordIdSecretGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Pending Registration
         * @param {string} id 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingRegistrationPendingRegistrationIdSecretGet(id: string, secret: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingRegistrationPendingRegistrationIdSecretGet(id, secret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPendingRegistrationPendingRegistrationIdSecretGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login For Access Token
         * @param {string} username 
         * @param {string} password 
         * @param {GrantType} [grantType] 
         * @param {string} [scope] 
         * @param {ClientId} [clientId] 
         * @param {ClientSecret} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginForAccessTokenTokenPost(username: string, password: string, grantType?: GrantType, scope?: string, clientId?: ClientId, clientSecret?: ClientSecret, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginForAccessTokenTokenPost(username, password, grantType, scope, clientId, clientSecret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.loginForAccessTokenTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.logoutLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read Users Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readUsersMeMeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readUsersMeMeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.readUsersMeMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register User
         * @param {RegisterUserRequest} registerUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerUserRegisterPost(registerUserRequest: RegisterUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerUserRegisterPost(registerUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.registerUserRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordResetPasswordPost(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordResetPasswordPost(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.resetPasswordResetPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Email
         * @param {EmailDetails} emailDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailSendEmailPost(emailDetails: EmailDetails, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailSendEmailPost(emailDetails, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendEmailSendEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Password Reset
         * @param {string} id 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordResetResetPasswordIdSecretGet(id: string, secret: string, options?: any): AxiosPromise<string> {
            return localVarFp.getPasswordResetResetPasswordIdSecretGet(id, secret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pending Registration
         * @param {string} id 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingRegistrationPendingRegistrationIdSecretGet(id: string, secret: string, options?: any): AxiosPromise<string> {
            return localVarFp.getPendingRegistrationPendingRegistrationIdSecretGet(id, secret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login For Access Token
         * @param {string} username 
         * @param {string} password 
         * @param {GrantType} [grantType] 
         * @param {string} [scope] 
         * @param {ClientId} [clientId] 
         * @param {ClientSecret} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginForAccessTokenTokenPost(username: string, password: string, grantType?: GrantType, scope?: string, clientId?: ClientId, clientSecret?: ClientSecret, options?: any): AxiosPromise<Token> {
            return localVarFp.loginForAccessTokenTokenPost(username, password, grantType, scope, clientId, clientSecret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutLogoutPost(options?: any): AxiosPromise<any> {
            return localVarFp.logoutLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read Users Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUsersMeMeGet(options?: any): AxiosPromise<MeResponse> {
            return localVarFp.readUsersMeMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register User
         * @param {RegisterUserRequest} registerUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUserRegisterPost(registerUserRequest: RegisterUserRequest, options?: any): AxiosPromise<any> {
            return localVarFp.registerUserRegisterPost(registerUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordResetPasswordPost(resetPasswordRequest: ResetPasswordRequest, options?: any): AxiosPromise<any> {
            return localVarFp.resetPasswordResetPasswordPost(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Email
         * @param {EmailDetails} emailDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailSendEmailPost(emailDetails: EmailDetails, options?: any): AxiosPromise<any> {
            return localVarFp.sendEmailSendEmailPost(emailDetails, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Get Password Reset
     * @param {string} id 
     * @param {string} secret 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPasswordResetResetPasswordIdSecretGet(id: string, secret: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPasswordResetResetPasswordIdSecretGet(id, secret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pending Registration
     * @param {string} id 
     * @param {string} secret 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPendingRegistrationPendingRegistrationIdSecretGet(id: string, secret: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPendingRegistrationPendingRegistrationIdSecretGet(id, secret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login For Access Token
     * @param {string} username 
     * @param {string} password 
     * @param {GrantType} [grantType] 
     * @param {string} [scope] 
     * @param {ClientId} [clientId] 
     * @param {ClientSecret} [clientSecret] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginForAccessTokenTokenPost(username: string, password: string, grantType?: GrantType, scope?: string, clientId?: ClientId, clientSecret?: ClientSecret, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginForAccessTokenTokenPost(username, password, grantType, scope, clientId, clientSecret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public logoutLogoutPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).logoutLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read Users Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public readUsersMeMeGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).readUsersMeMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register User
     * @param {RegisterUserRequest} registerUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerUserRegisterPost(registerUserRequest: RegisterUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerUserRegisterPost(registerUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset Password
     * @param {ResetPasswordRequest} resetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resetPasswordResetPasswordPost(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resetPasswordResetPasswordPost(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Email
     * @param {EmailDetails} emailDetails 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendEmailSendEmailPost(emailDetails: EmailDetails, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendEmailSendEmailPost(emailDetails, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Analyze Pdf
         * @param {Array<File>} files 
         * @param {ContractorId} [contractorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzePdfDocumentAnalyzePost: async (files: Array<File>, contractorId?: ContractorId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('analyzePdfDocumentAnalyzePost', 'files', files)
            const localVarPath = `/document/analyze`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (contractorId !== undefined) {
                for (const [key, value] of Object.entries(contractorId)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsDocumentJobsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Analyze Pdf
         * @param {Array<File>} files 
         * @param {ContractorId} [contractorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzePdfDocumentAnalyzePost(files: Array<File>, contractorId?: ContractorId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzePdfDocumentAnalyzePost(files, contractorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.analyzePdfDocumentAnalyzePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobsDocumentJobsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobsDocumentJobsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.getJobsDocumentJobsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @summary Analyze Pdf
         * @param {Array<File>} files 
         * @param {ContractorId} [contractorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzePdfDocumentAnalyzePost(files: Array<File>, contractorId?: ContractorId, options?: any): AxiosPromise<any> {
            return localVarFp.analyzePdfDocumentAnalyzePost(files, contractorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Jobs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsDocumentJobsGet(options?: any): AxiosPromise<Array<JobResponse>> {
            return localVarFp.getJobsDocumentJobsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @summary Analyze Pdf
     * @param {Array<File>} files 
     * @param {ContractorId} [contractorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public analyzePdfDocumentAnalyzePost(files: Array<File>, contractorId?: ContractorId, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).analyzePdfDocumentAnalyzePost(files, contractorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Jobs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getJobsDocumentJobsGet(options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).getJobsDocumentJobsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InspectionsApi - axios parameter creator
 * @export
 */
export const InspectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Analysis
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnalysisInspectionsAnalysisIdDelete: async (analysisId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('deleteAnalysisInspectionsAnalysisIdDelete', 'analysisId', analysisId)
            const localVarPath = `/inspections/{analysis_id}`
                .replace(`{${"analysis_id"}}`, encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Analyses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysesInspectionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/inspections/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Analysis File
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisFileInspectionsAnalysisIdFileGet: async (analysisId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('getAnalysisFileInspectionsAnalysisIdFileGet', 'analysisId', analysisId)
            const localVarPath = `/inspections/{analysis_id}/file`
                .replace(`{${"analysis_id"}}`, encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Analysis Image
         * @param {string} analysisId 
         * @param {number} pageNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisImageInspectionsAnalysisIdImageGet: async (analysisId: string, pageNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('getAnalysisImageInspectionsAnalysisIdImageGet', 'analysisId', analysisId)
            // verify required parameter 'pageNumber' is not null or undefined
            assertParamExists('getAnalysisImageInspectionsAnalysisIdImageGet', 'pageNumber', pageNumber)
            const localVarPath = `/inspections/{analysis_id}/image`
                .replace(`{${"analysis_id"}}`, encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNumber !== undefined) {
                localVarQueryParameter['page_number'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Analysis
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisInspectionsAnalysisIdGet: async (analysisId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('getAnalysisInspectionsAnalysisIdGet', 'analysisId', analysisId)
            const localVarPath = `/inspections/{analysis_id}`
                .replace(`{${"analysis_id"}}`, encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Inspection Validations
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionValidationsInspectionsAnalysisIdValidationsGet: async (analysisId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('getInspectionValidationsInspectionsAnalysisIdValidationsGet', 'analysisId', analysisId)
            const localVarPath = `/inspections/{analysis_id}/validations`
                .replace(`{${"analysis_id"}}`, encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Override Validation
         * @param {string} analysisId 
         * @param {string} outcomeId 
         * @param {boolean} newOutcome 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch: async (analysisId: string, outcomeId: string, newOutcome: boolean, reason: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch', 'analysisId', analysisId)
            // verify required parameter 'outcomeId' is not null or undefined
            assertParamExists('overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch', 'outcomeId', outcomeId)
            // verify required parameter 'newOutcome' is not null or undefined
            assertParamExists('overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch', 'newOutcome', newOutcome)
            // verify required parameter 'reason' is not null or undefined
            assertParamExists('overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch', 'reason', reason)
            const localVarPath = `/inspections/{analysis_id}/validation/{outcome_id}`
                .replace(`{${"analysis_id"}}`, encodeURIComponent(String(analysisId)))
                .replace(`{${"outcome_id"}}`, encodeURIComponent(String(outcomeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (newOutcome !== undefined) {
                localVarQueryParameter['new_outcome'] = newOutcome;
            }

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Analysis Asset Id
         * @param {string} analysisId 
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalysisAssetIdInspectionsAnalysisIdPost: async (analysisId: string, assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('setAnalysisAssetIdInspectionsAnalysisIdPost', 'analysisId', analysisId)
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('setAnalysisAssetIdInspectionsAnalysisIdPost', 'assetId', assetId)
            const localVarPath = `/inspections/{analysis_id}`
                .replace(`{${"analysis_id"}}`, encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assetId !== undefined) {
                localVarQueryParameter['asset_id'] = assetId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Analysis Contractor
         * @param {string} analysisId 
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalysisContractorInspectionsAnalysisIdContractorPost: async (analysisId: string, contractorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('setAnalysisContractorInspectionsAnalysisIdContractorPost', 'analysisId', analysisId)
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('setAnalysisContractorInspectionsAnalysisIdContractorPost', 'contractorId', contractorId)
            const localVarPath = `/inspections/{analysis_id}/contractor`
                .replace(`{${"analysis_id"}}`, encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contractorId !== undefined) {
                localVarQueryParameter['contractor_id'] = contractorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InspectionsApi - functional programming interface
 * @export
 */
export const InspectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InspectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Analysis
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnalysisInspectionsAnalysisIdDelete(analysisId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnalysisInspectionsAnalysisIdDelete(analysisId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.deleteAnalysisInspectionsAnalysisIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Analyses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalysesInspectionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalysisResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalysesInspectionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getAnalysesInspectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Analysis File
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalysisFileInspectionsAnalysisIdFileGet(analysisId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalysisFileInspectionsAnalysisIdFileGet(analysisId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getAnalysisFileInspectionsAnalysisIdFileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Analysis Image
         * @param {string} analysisId 
         * @param {number} pageNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalysisImageInspectionsAnalysisIdImageGet(analysisId: string, pageNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalysisImageInspectionsAnalysisIdImageGet(analysisId, pageNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getAnalysisImageInspectionsAnalysisIdImageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Analysis
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalysisInspectionsAnalysisIdGet(analysisId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentAIAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalysisInspectionsAnalysisIdGet(analysisId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getAnalysisInspectionsAnalysisIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Inspection Validations
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInspectionValidationsInspectionsAnalysisIdValidationsGet(analysisId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInspectionValidationsInspectionsAnalysisIdValidationsGet(analysisId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getInspectionValidationsInspectionsAnalysisIdValidationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Override Validation
         * @param {string} analysisId 
         * @param {string} outcomeId 
         * @param {boolean} newOutcome 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch(analysisId: string, outcomeId: string, newOutcome: boolean, reason: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch(analysisId, outcomeId, newOutcome, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set Analysis Asset Id
         * @param {string} analysisId 
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAnalysisAssetIdInspectionsAnalysisIdPost(analysisId: string, assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAnalysisAssetIdInspectionsAnalysisIdPost(analysisId, assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.setAnalysisAssetIdInspectionsAnalysisIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set Analysis Contractor
         * @param {string} analysisId 
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAnalysisContractorInspectionsAnalysisIdContractorPost(analysisId: string, contractorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAnalysisContractorInspectionsAnalysisIdContractorPost(analysisId, contractorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.setAnalysisContractorInspectionsAnalysisIdContractorPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InspectionsApi - factory interface
 * @export
 */
export const InspectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InspectionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Analysis
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnalysisInspectionsAnalysisIdDelete(analysisId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteAnalysisInspectionsAnalysisIdDelete(analysisId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Analyses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysesInspectionsGet(options?: any): AxiosPromise<Array<AnalysisResponse>> {
            return localVarFp.getAnalysesInspectionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Analysis File
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisFileInspectionsAnalysisIdFileGet(analysisId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getAnalysisFileInspectionsAnalysisIdFileGet(analysisId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Analysis Image
         * @param {string} analysisId 
         * @param {number} pageNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisImageInspectionsAnalysisIdImageGet(analysisId: string, pageNumber: number, options?: any): AxiosPromise<any> {
            return localVarFp.getAnalysisImageInspectionsAnalysisIdImageGet(analysisId, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Analysis
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisInspectionsAnalysisIdGet(analysisId: string, options?: any): AxiosPromise<DocumentAIAnalysisResponse> {
            return localVarFp.getAnalysisInspectionsAnalysisIdGet(analysisId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Inspection Validations
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionValidationsInspectionsAnalysisIdValidationsGet(analysisId: string, options?: any): AxiosPromise<ValidationsResponse> {
            return localVarFp.getInspectionValidationsInspectionsAnalysisIdValidationsGet(analysisId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Override Validation
         * @param {string} analysisId 
         * @param {string} outcomeId 
         * @param {boolean} newOutcome 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch(analysisId: string, outcomeId: string, newOutcome: boolean, reason: string, options?: any): AxiosPromise<any> {
            return localVarFp.overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch(analysisId, outcomeId, newOutcome, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Analysis Asset Id
         * @param {string} analysisId 
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalysisAssetIdInspectionsAnalysisIdPost(analysisId: string, assetId: string, options?: any): AxiosPromise<any> {
            return localVarFp.setAnalysisAssetIdInspectionsAnalysisIdPost(analysisId, assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Analysis Contractor
         * @param {string} analysisId 
         * @param {string} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalysisContractorInspectionsAnalysisIdContractorPost(analysisId: string, contractorId: string, options?: any): AxiosPromise<any> {
            return localVarFp.setAnalysisContractorInspectionsAnalysisIdContractorPost(analysisId, contractorId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InspectionsApi - object-oriented interface
 * @export
 * @class InspectionsApi
 * @extends {BaseAPI}
 */
export class InspectionsApi extends BaseAPI {
    /**
     * 
     * @summary Delete Analysis
     * @param {string} analysisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public deleteAnalysisInspectionsAnalysisIdDelete(analysisId: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).deleteAnalysisInspectionsAnalysisIdDelete(analysisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Analyses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getAnalysesInspectionsGet(options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getAnalysesInspectionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Analysis File
     * @param {string} analysisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getAnalysisFileInspectionsAnalysisIdFileGet(analysisId: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getAnalysisFileInspectionsAnalysisIdFileGet(analysisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Analysis Image
     * @param {string} analysisId 
     * @param {number} pageNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getAnalysisImageInspectionsAnalysisIdImageGet(analysisId: string, pageNumber: number, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getAnalysisImageInspectionsAnalysisIdImageGet(analysisId, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Analysis
     * @param {string} analysisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getAnalysisInspectionsAnalysisIdGet(analysisId: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getAnalysisInspectionsAnalysisIdGet(analysisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Inspection Validations
     * @param {string} analysisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getInspectionValidationsInspectionsAnalysisIdValidationsGet(analysisId: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getInspectionValidationsInspectionsAnalysisIdValidationsGet(analysisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Override Validation
     * @param {string} analysisId 
     * @param {string} outcomeId 
     * @param {boolean} newOutcome 
     * @param {string} reason 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch(analysisId: string, outcomeId: string, newOutcome: boolean, reason: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch(analysisId, outcomeId, newOutcome, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Analysis Asset Id
     * @param {string} analysisId 
     * @param {string} assetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public setAnalysisAssetIdInspectionsAnalysisIdPost(analysisId: string, assetId: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).setAnalysisAssetIdInspectionsAnalysisIdPost(analysisId, assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Analysis Contractor
     * @param {string} analysisId 
     * @param {string} contractorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public setAnalysisContractorInspectionsAnalysisIdContractorPost(analysisId: string, contractorId: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).setAnalysisContractorInspectionsAnalysisIdContractorPost(analysisId, contractorId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Inspections Report
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsReportReportsInspectionsGet: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('inspectionsReportReportsInspectionsGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('inspectionsReportReportsInspectionsGet', 'endDate', endDate)
            const localVarPath = `/reports/inspections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Inspections Report
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectionsReportReportsInspectionsGet(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectionsReportReportsInspectionsGet(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.inspectionsReportReportsInspectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Inspections Report
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionsReportReportsInspectionsGet(startDate: string, endDate: string, options?: any): AxiosPromise<any> {
            return localVarFp.inspectionsReportReportsInspectionsGet(startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @summary Inspections Report
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public inspectionsReportReportsInspectionsGet(startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).inspectionsReportReportsInspectionsGet(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatsApi - axios parameter creator
 * @export
 */
export const StatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Compliance Over Time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComplianceOverTimeStatsComplianceOverTimeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stats/compliance-over-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatsApi - functional programming interface
 * @export
 */
export const StatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Compliance Over Time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComplianceOverTimeStatsComplianceOverTimeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetComplianceSnapshot>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComplianceOverTimeStatsComplianceOverTimeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatsApi.getComplianceOverTimeStatsComplianceOverTimeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatsApi - factory interface
 * @export
 */
export const StatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Compliance Over Time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComplianceOverTimeStatsComplianceOverTimeGet(options?: any): AxiosPromise<Array<AssetComplianceSnapshot>> {
            return localVarFp.getComplianceOverTimeStatsComplianceOverTimeGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatsApi - object-oriented interface
 * @export
 * @class StatsApi
 * @extends {BaseAPI}
 */
export class StatsApi extends BaseAPI {
    /**
     * 
     * @summary Get Compliance Over Time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    public getComplianceOverTimeStatsComplianceOverTimeGet(options?: RawAxiosRequestConfig) {
        return StatsApiFp(this.configuration).getComplianceOverTimeStatsComplianceOverTimeGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add User
         * @param {NewUserRequest} newUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserUsersPost: async (newUserRequest: NewUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newUserRequest' is not null or undefined
            assertParamExists('addUserUsersPost', 'newUserRequest', newUserRequest)
            const localVarPath = `/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Pending Registration
         * @param {string} pendingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePendingRegistrationUsersPendingPendingIdDelete: async (pendingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pendingId' is not null or undefined
            assertParamExists('deletePendingRegistrationUsersPendingPendingIdDelete', 'pendingId', pendingId)
            const localVarPath = `/users/pending/{pending_id}`
                .replace(`{${"pending_id"}}`, encodeURIComponent(String(pendingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pending Registrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingRegistrationsUsersPendingGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUsersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh Pending Registration
         * @param {string} pendingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPendingRegistrationUsersPendingPendingIdRefreshPost: async (pendingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pendingId' is not null or undefined
            assertParamExists('refreshPendingRegistrationUsersPendingPendingIdRefreshPost', 'pendingId', pendingId)
            const localVarPath = `/users/pending/{pending_id}/refresh`
                .replace(`{${"pending_id"}}`, encodeURIComponent(String(pendingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove User From Tenant
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromTenantUsersUserIdDelete: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserFromTenantUsersUserIdDelete', 'userId', userId)
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset User Password
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPasswordUsersUserIdResetPasswordPost: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetUserPasswordUsersUserIdResetPasswordPost', 'userId', userId)
            const localVarPath = `/users/{user_id}/reset_password`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update User Details
         * @param {UpdateUserDetailsRequest} updateUserDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetailsUsersDetailsPatch: async (updateUserDetailsRequest: UpdateUserDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserDetailsRequest' is not null or undefined
            assertParamExists('updateUserDetailsUsersDetailsPatch', 'updateUserDetailsRequest', updateUserDetailsRequest)
            const localVarPath = `/users/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update User
         * @param {string} userId 
         * @param {UserTenantInfo} userTenantInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserUsersUserIdPatch: async (userId: string, userTenantInfo: UserTenantInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserUsersUserIdPatch', 'userId', userId)
            // verify required parameter 'userTenantInfo' is not null or undefined
            assertParamExists('updateUserUsersUserIdPatch', 'userTenantInfo', userTenantInfo)
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTenantInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add User
         * @param {NewUserRequest} newUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserUsersPost(newUserRequest: NewUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserUsersPost(newUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.addUserUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Pending Registration
         * @param {string} pendingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePendingRegistrationUsersPendingPendingIdDelete(pendingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePendingRegistrationUsersPendingPendingIdDelete(pendingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deletePendingRegistrationUsersPendingPendingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Pending Registrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingRegistrationsUsersPendingGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingRegistrationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingRegistrationsUsersPendingGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getPendingRegistrationsUsersPendingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersUsersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersUsersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsersUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh Pending Registration
         * @param {string} pendingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshPendingRegistrationUsersPendingPendingIdRefreshPost(pendingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshPendingRegistrationUsersPendingPendingIdRefreshPost(pendingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.refreshPendingRegistrationUsersPendingPendingIdRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove User From Tenant
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserFromTenantUsersUserIdDelete(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserFromTenantUsersUserIdDelete(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.removeUserFromTenantUsersUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset User Password
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPasswordUsersUserIdResetPasswordPost(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPasswordUsersUserIdResetPasswordPost(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.resetUserPasswordUsersUserIdResetPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update User Details
         * @param {UpdateUserDetailsRequest} updateUserDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDetailsUsersDetailsPatch(updateUserDetailsRequest: UpdateUserDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDetailsUsersDetailsPatch(updateUserDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserDetailsUsersDetailsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update User
         * @param {string} userId 
         * @param {UserTenantInfo} userTenantInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserUsersUserIdPatch(userId: string, userTenantInfo: UserTenantInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserUsersUserIdPatch(userId, userTenantInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserUsersUserIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Add User
         * @param {NewUserRequest} newUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserUsersPost(newUserRequest: NewUserRequest, options?: any): AxiosPromise<any> {
            return localVarFp.addUserUsersPost(newUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Pending Registration
         * @param {string} pendingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePendingRegistrationUsersPendingPendingIdDelete(pendingId: string, options?: any): AxiosPromise<any> {
            return localVarFp.deletePendingRegistrationUsersPendingPendingIdDelete(pendingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pending Registrations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingRegistrationsUsersPendingGet(options?: any): AxiosPromise<Array<PendingRegistrationResponse>> {
            return localVarFp.getPendingRegistrationsUsersPendingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUsersGet(options?: any): AxiosPromise<UserResp> {
            return localVarFp.getUsersUsersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh Pending Registration
         * @param {string} pendingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPendingRegistrationUsersPendingPendingIdRefreshPost(pendingId: string, options?: any): AxiosPromise<any> {
            return localVarFp.refreshPendingRegistrationUsersPendingPendingIdRefreshPost(pendingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove User From Tenant
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromTenantUsersUserIdDelete(userId: string, options?: any): AxiosPromise<any> {
            return localVarFp.removeUserFromTenantUsersUserIdDelete(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset User Password
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPasswordUsersUserIdResetPasswordPost(userId: string, options?: any): AxiosPromise<any> {
            return localVarFp.resetUserPasswordUsersUserIdResetPasswordPost(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update User Details
         * @param {UpdateUserDetailsRequest} updateUserDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetailsUsersDetailsPatch(updateUserDetailsRequest: UpdateUserDetailsRequest, options?: any): AxiosPromise<any> {
            return localVarFp.updateUserDetailsUsersDetailsPatch(updateUserDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update User
         * @param {string} userId 
         * @param {UserTenantInfo} userTenantInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserUsersUserIdPatch(userId: string, userTenantInfo: UserTenantInfo, options?: any): AxiosPromise<any> {
            return localVarFp.updateUserUsersUserIdPatch(userId, userTenantInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Add User
     * @param {NewUserRequest} newUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public addUserUsersPost(newUserRequest: NewUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).addUserUsersPost(newUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Pending Registration
     * @param {string} pendingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deletePendingRegistrationUsersPendingPendingIdDelete(pendingId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deletePendingRegistrationUsersPendingPendingIdDelete(pendingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pending Registrations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getPendingRegistrationsUsersPendingGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getPendingRegistrationsUsersPendingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsersUsersGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersUsersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh Pending Registration
     * @param {string} pendingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public refreshPendingRegistrationUsersPendingPendingIdRefreshPost(pendingId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).refreshPendingRegistrationUsersPendingPendingIdRefreshPost(pendingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove User From Tenant
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public removeUserFromTenantUsersUserIdDelete(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).removeUserFromTenantUsersUserIdDelete(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset User Password
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetUserPasswordUsersUserIdResetPasswordPost(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetUserPasswordUsersUserIdResetPasswordPost(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update User Details
     * @param {UpdateUserDetailsRequest} updateUserDetailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserDetailsUsersDetailsPatch(updateUserDetailsRequest: UpdateUserDetailsRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserDetailsUsersDetailsPatch(updateUserDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update User
     * @param {string} userId 
     * @param {UserTenantInfo} userTenantInfo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserUsersUserIdPatch(userId: string, userTenantInfo: UserTenantInfo, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserUsersUserIdPatch(userId, userTenantInfo, options).then((request) => request(this.axios, this.basePath));
    }
}



